<template>
  <div class="p-the-template-m c-common-footer-fixed">
    <div class="c-common-footer-fixed__inner">
      <TheSimpleHeader v-show="isSimpleHeader" />
      <TheHeader v-show="!isSimpleHeader" ref="theHeader" />

      <div class="c-common-inner">
        <TheBreadcrumb />

        <div class="p-the-template-m__inner">
          <CommonHeading class="p-the-template-m__heading">
            <slot name="heading"></slot>
          </CommonHeading>

          <div class="p-the-template-m__card">
            <TheFormStep
              v-if="step"
              :step="step"
              :options="stepOptions"
            ></TheFormStep>
            <slot name="body"></slot>
          </div>

          <slot></slot>
        </div>
      </div>
    </div>
    <TheFooter />
  </div>
</template>
<script lang="ts">
import TheHeader from "@/common/components/organisms/TheHeader.vue";
import TheSimpleHeader from "@/common/components/organisms/TheSimpleHeader.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";
import TheFormStep from "@/common/components/organisms/TheFormStep.vue";
import CommonHeading from "@/common/components/atoms/CommonHeading.vue";
import TheBreadcrumb from "@/common/components/organisms/TheBreadcrumb.vue";
import { Options, Vue } from 'vue-class-component';

@Options({
  components: {
    TheHeader,
    TheSimpleHeader,
    TheFooter,
    TheFormStep,
    CommonHeading,
    TheBreadcrumb
  }
})
export default class TheTemplateM extends Vue {
  step = false;
  stepOptions = [];
  isSimpleHeader = false;

  declare $refs: {
    theHeader: TheHeader;
  };
}
</script>
<style lang="scss" scoped>
.p-the-template-m {
  background-color: $common-bg;

  @include sp {
    background-color: $common-white;
  }

  &__inner {
    padding-top: rem(40);
    padding-bottom: rem(80);

    @include sp {
      padding-top: rem(20);
      padding-bottom: rem(40);
    }
  }

  &__heading {
    @include sp {
      font-size: rem(20);
      line-height: (27/20);
    }
  }

  &__card {
    margin-top: rem(32);
    border-radius: px(4);

    @include pc {
      background-color: $common-white;
      padding: rem(72) 0;
    }
  }
}
</style>
